<template>
  <div class="cadfm-container-horizontal">
            <Left  v-show="isVisibleLeft" :lang="lang.Left"></Left>
            <Middle   :lang="lang.Middle"></Middle>
            <!--<Right :lang="lang.Right"></Right>-->
 </div>
</template>

<script>
import Left from "@/components/ProjectManager/Views/Properties/Left/Left";
import Middle from "@/components/ProjectManager/Views/Properties/Middle/Middle";
//import Right from '@/components/PartManager/Views/Categories/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: "Properties",
  components: {
    Left,
    Middle
    //Right
  },
  props:{
    lang: Object
  },
  data() {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    };
  }
};
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/Properties.vue